import React, { useState, useContext } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Table from 'react-bootstrap/Table'
import TableFooter from 'shared/tables/table-footer'
import TableLoading from 'shared/tables/table-loading'
import MutedText from 'shared/forms/muted-text'
import { useDataAccessRoles } from 'api/hooks/use-data-access-roles'
import UserContext from 'context/user-context'
import AccessToggle from './AccessToggle'
import { mapAccessType } from '../helper'

function EmployeesTab({ dataAccessId }) {
  const { municipality } = useContext(UserContext)
  const defaultParams = {
    page: 1,
    perPage: 25,
    data_access_id: dataAccessId,
    hideNoAccess: true,
    hideInactiveRoles: true
  }
  const [params, setParams] = useState(defaultParams)
  const { data, isSuccess, isLoading } = useDataAccessRoles({
    params: params
  })

  
  return (
    <Row>
      <Col sm={12}>
        <Card className="border">
          <Card.Header className="bg-white">
            <Row>
              <Col sm={'auto'}>
                <div className="text-info mt-1">Roles</div>
              </Col>
              <Col sm={'auto'}>
                <div className="d-flex justify-content-start ms-3">
                  <AccessToggle params={params} setParams={setParams} />
                </div>
              </Col>
              <Col sm={'auto'}>
                <div className="d-flex justify-content-start ms-3">
                  <div className="form-check form-switch mt-1">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="hideInactiveRoles"
                      checked={params.hideInactiveRoles}
                      onChange={() =>
                        setParams({
                          ...params,
                          hideInactiveRoles: !params.hideInactiveRoles
                        })
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="hideInactiveRoles"
                    >
                      Hide Inactive Roles
                    </label>
                  </div>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <Table responsive size="sm">
              <thead>
                <tr>
                  <th>Role</th>
                  <th>Status</th>
                  <th>Access</th>
                  <th>Program</th>
                  <th>Details</th>
                </tr>
              </thead>

              <tbody>
                {isLoading && <TableLoading columns={5} />}
                {isSuccess &&
                  data.data.map((row) => (
                    <tr key={`role-data-access-${row.id}`}>
                      <td>
                        <a
                          href={`/roles/${row.role_id}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {row?.role?.name}
                        </a>
                      </td>
                      <td>
                        <MutedText className="ms-2">
                          {row?.role?.status}
                        </MutedText>
                      </td>
                      <td>
                        <MutedText className="ms-2">
                          {row?.no_access ? 'No Access' : 'Access'}
                        </MutedText>
                      </td>
                      <td>{row?.program_name || row?.program_id}</td>
                      <td>
                        {mapAccessType(municipality, row?.access_type)}:{' '}
                        {row?.start1} - {row?.end1}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
            {isSuccess && (
              <TableFooter
                meta={data.meta}
                params={params}
                setParams={setParams}
              />
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default EmployeesTab
